require('!!raw-loader!/builds/787586/v2/src/index.html');